import React from "react";
export default function Sidebar({ navigate }) {
  const nav = [
    ["/game", "✈", "Aviator"],
    ["/history", "◷", "Bet History"],
  ];
  return (
    <aside className="sidebar">
      <div className="sidebar-title">MENU</div>
      {nav.map((n) => (
        <button
          key={n[0]}
          className={window.location.pathname === n[0] ? "active" : ""}
          onClick={() => navigate(n[0])}
        >
          <i>{n[1]}</i>
          {n[2]}
        </button>
      ))}
    </aside>
  );
}
